import { isChartWithAllOptions } from "./echartOptions";
import { defaultEchartOption } from "./defaultEchartOption";

const defaults = {
  default: {
    xAxis: { ...defaultEchartOption.xAxis },
    yAxis: { ...defaultEchartOption.yAxis }
  },
};

/**
 * Retorna dados relativo aos eixos X e Y de acordo com o gráfico selecionado, para o gráfico de barras
 * ou linhas, por exemplo, nós temos linhas grades, portanto temos uma configuração pré-definida para
 * estes tipos de gráficos.
 */
export function getAxisConfig(chartType, theme, checkedOptions) {
  if (isChartWithAllOptions(chartType)) {
    const axisDefault = defaults[chartType] || defaults.default;

    return {
      yAxis: {
        ...axisDefault.yAxis,
        axisLabel: { color: theme.title === 'dark' ? theme.colors.charts.axis.y.label : '#610082' },
        splitLine: {
          show: checkedOptions.gridLines,
          lineStyle: {
            color: theme.title === 'dark' ? '#4C555C' : '#A1B4C4',
          },
        },
        axisLine: {
          show: checkedOptions.gridLines,
          lineStyle: {
            color: theme.title === 'dark' ? '#4C555C' : '#A1B4C4',
          },
        },
        axisTick: {
          show: checkedOptions.gridLines,
        },
      },
      xAxis: {
        ...axisDefault.xAxis,
        ...(chartType === 'line' ? {
          data: ['ENUNCIADO 1', 'ENUNCIADO 2'],
          axisLabel: { color: theme.title === 'dark' ? theme.colors.charts.axis.y.label : '#610082' },
        } : {}),
        axisLine: {
          show: checkedOptions.gridLines,
          lineStyle: {
            color: theme.title === 'dark' ? '#4C555C' : '#A1B4C4',
            fontWeight: 400,
            lineHeight: 16,
          },
        },
        axisTick: {
          show: checkedOptions.gridLines,
        },
      },
    };
  }

  return {
    xAxis: {
      show: false,
    },
    yAxis: {
      show: false,
    },
  };
}